export const reloadPage = () => {
    const indexUrl = document.querySelector('.index-url')?.textContent;
    if (indexUrl) {
        window.location.replace(indexUrl);
    } else {
        window.location.reload();
    }
}